import React from 'react';
import Layout from '../components/layout/Layout';
import { services } from '../data/mock';
import { Palette, Smartphone, Sparkles, Code, Globe, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import StarburstDecor from '../components/ui/StarburstDecor';

const iconMap = {
  Palette: Palette,
  Smartphone: Smartphone,
  Sparkles: Sparkles,
  Code: Code,
  Globe: Globe
};

const ServicesPage = () => {
  return (
    <Layout>
      {/* Hero */}
      <section className="bg-white py-16 relative">
        <div className="container-main">
          <div className="max-w-2xl">
            <h1 className="text-4xl md:text-5xl font-bold text-navy leading-tight">
              Our Services
            </h1>
            <p className="mt-6 text-gray-600">
              We offer comprehensive digital solutions to help your business thrive in the modern digital landscape.
            </p>
          </div>
          <div className="absolute top-8 right-8 hidden lg:block">
            <StarburstDecor size={100} />
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="bg-white py-12">
        <div className="container-main">
          <div className="grid md:grid-cols-2 gap-8">
            {services.map((service, index) => {
              const IconComponent = iconMap[service.icon] || Sparkles;
              const isEven = index % 2 === 0;
              
              return (
                <div
                  key={service.id}
                  className={`p-8 rounded-xl ${isEven ? 'bg-navy text-white' : 'bg-lime text-navy'}`}
                >
                  <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 ${
                    isEven ? 'bg-lime' : 'bg-navy'
                  }`}>
                    <IconComponent className={`w-8 h-8 ${isEven ? 'text-navy' : 'text-lime'}`} />
                  </div>
                  <h3 className="text-2xl font-bold mb-4">{service.title}</h3>
                  <p className={`leading-relaxed ${isEven ? 'text-white/80' : 'text-navy/80'}`}>
                    {service.description}
                  </p>
                  <Link
                    to="/contact"
                    className={`mt-6 inline-flex items-center gap-2 text-sm font-medium ${
                      isEven ? 'text-lime' : 'text-navy'
                    }`}
                  >
                    Get Started
                    <ArrowUpRight className="w-4 h-4" />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-lime py-20">
        <div className="container-main text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6">
            Ready to start your project?
          </h2>
          <p className="text-navy/70 max-w-md mx-auto mb-8">
            Let's discuss how we can help bring your vision to life with our expertise in design and development.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-navy text-white px-8 py-4 rounded-full text-sm font-medium transition-all hover:bg-navy/90 group"
          >
            Let's Talk
            <span className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center group-hover:bg-white/30 transition-colors">
              <ArrowUpRight className="w-4 h-4" />
            </span>
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default ServicesPage;
